<template>
  <div class="general">
    <container>
      <template v-slot:header>
        {{$ml.get(`General Information`)}}
      </template>
      <div class="content">
        <div v-for="(value, key, i) in data" :key="i">
          <span>
            {{$ml.get(value.name)}}
          </span>
          <span>
            {{typeof(value.value) == 'string' ? $ml.get(value.value) : value.value}}
          </span>
        </div>
      </div>
    </container>
  </div>
</template>

<script>
import Container from "@/components/common/HeadedContainer"

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  components: {
    Container
  }
}
</script>

<style lang="scss" scoped>
  .general {
    .content {
      width: 100%;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      padding: 15px;
      box-sizing: border-box;

      div {
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        span {
          &:first-child {
            margin: 0 0 12px 0;
            font-size: 13px;
            font-weight: 400;
          }
          &:last-child {
            margin: 0;
            font-weight: 500;
            font-size: 16px;
          }
        }
      }
    }
  }
</style>
